import {
  DELETE_ASSIGNMENT_EXTENSIONS_FAILURE,
  GET_ASSIGNMENT_EXTENSIONS_FAILURE,
  POST_ASSIGNMENT_EXTENSIONS_FAILURE,
  UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE
} from 'modules/authorizations/store/types/globalTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  deleteAssignmentExtension,
  getAssignmentExtensions,
  postAssignmentExtension,
  postGlobalInfo,
  updateAssignmentExtension,
  updateGlobalInfo
} from 'modules/authorizations/store/actions/global.actions';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';

import CrudTableCard from 'modules/common/crudTableCard.component';
import Spinner from 'modules/common/spinner.component';
import { enumColumn } from 'modules/common/enumTableColumn';

const AssignmentExtensionsCrud = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { globalExtensions, assignmentId, isReadOnly, enumerations, authId } = props;

  const tabs = [{ header: 'Assignment Extensions', order: 1, iconPath: ['fas', 'suitcase-rolling'] }];

  const extensionTypes =
    enumerations && enumerations.globalExtensionTypes && enumerations.globalExtensionTypes.length > 0
      ? enumerations.globalExtensionTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const assignmentExtensionsColumns = [
    {
      accessorKey: 'extensionStartDate',
      header: 'Extension Start Date',
      type: 'date',
      required: true,
      size: 70,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '')
    },
    {
      accessorKey: 'extensionEndDate',
      header: 'Extension End Date',
      type: 'date',
      required: false,
      size: 50,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '')
    },
    {
      ...enumColumn('extensionTypeId', extensionTypes),
      header: 'Extension Type',
      type: 'dropdown-v2',
      required: false,
      options: extensionTypes,
      size: 50,
      Cell: ({ cell }) => cell.getValue() && <p>{cell.getValue()}</p>
    },
    { accessorKey: 'extensionNote', header: 'Extension Note', type: 'text', required: false, size: 50 }
  ];

  const updateExtension = async (extension, values) => {
    let request = { ...values };

    values.globalAssignmentId = assignmentId;
    values.globalExtensionId = extension.original.globalExtensionId;

    request.extensionStartDate = !values.extensionStartDate || values.extensionStartDate === '' ? null : values.extensionStartDate;
    request.extensionEndDate = !values.extensionEndDate || values.extensionEndDate === '' ? null : values.extensionEndDate;
    request.extensionTypeId = !values.extensionTypeId || values.extensionTypeId === '' ? '00000000-0000-0000-0000-000000000000' : values.extensionTypeId;

    setIsLoading(true);
    const resp = await props.updateAssignmentExtension(values);
    if (resp.type === UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getAssignmentExtensions(assignmentId);
      setIsLoading(false);
      if (getResp.type === GET_ASSIGNMENT_EXTENSIONS_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const createExtension = async values => {
    let request = { ...values };
    request.globalAssignmentId = assignmentId;

    request.extensionStartDate = !values.extensionStartDate || values.extensionStartDate === '' ? null : values.extensionStartDate;
    request.extensionEndDate = !values.extensionEndDate || values.extensionEndDate === '' ? null : values.extensionEndDate;
    request.extensionTypeId = !values.extensionTypeId || values.extensionTypeId === '' ? '00000000-0000-0000-0000-000000000000' : values.extensionTypeId;

    setIsLoading(true);
    const resp = await props.postAssignmentExtension(request, authId);
    if (resp.type === POST_ASSIGNMENT_EXTENSIONS_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getAssignmentExtensions(assignmentId);
      setIsLoading(false);
      if (getResp.type === GET_ASSIGNMENT_EXTENSIONS_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const deleteExtension = async extension => {
    const resp = await props.deleteAssignmentExtension(authId, extension.original.globalExtensionId);
    if (resp.type === DELETE_ASSIGNMENT_EXTENSIONS_FAILURE) {
      return false;
    } else {
      const getResp = await props.getAssignmentExtensions(assignmentId);
      if (getResp.type === GET_ASSIGNMENT_EXTENSIONS_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const summaries = [
    {
      adjustedColumns: assignmentExtensionsColumns,
      rows: globalExtensions ? globalExtensions : [],
      addButtonText: 'Add Extension',
      tab: 1,
      updateRow: updateExtension,
      createRow: createExtension,
      deleteRow: deleteExtension,
      hideEdit: isReadOnly
    }
  ];

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading && <CrudTableCard tabs={tabs} summaries={summaries} numColumns={5} />}
    </>
  );
};

export default compose(
  connect(null, {
    updateGlobalInfo,
    postGlobalInfo,
    showToast,
    updateAssignmentExtension,
    postAssignmentExtension,
    deleteAssignmentExtension,
    getAssignmentExtensions
  })
)(AssignmentExtensionsCrud);
